export interface UrlBuilderService {
    buildUrl(url: string, queryParams?: Record<string, unknown>): string;
    stripQuery(url: string): string;
}

export const urlBuilderService = (): UrlBuilderService => {
    const buildUrl = (url: string, queryParams = {}): string => {
        const baseUrl = stripQuery(url);

        const query = buildQuery(queryParams);
        if (!query) {
            return baseUrl;
        }

        return `${baseUrl}?${query}`;
    };

    const stripQuery = (url: string): string => {
        return url.split("?")[0];
    };

    const buildQuery = (queryParams: Record<string, unknown>, query = "", objName?: string): string => {
        let extendedQuery = query;

        for (const key of Object.keys(queryParams)) {
            const value = queryParams[key];

            extendedQuery = getExtendedQuery(key, value, extendedQuery, objName);
        }

        return extendedQuery;
    };

    const getExtendedQuery = (key: string, value: unknown, queryString: string, objName?: string) => {
        if (value === undefined) {
            return queryString;
        }
        if (typeof value === "object") {
            return buildQuery(value as Record<string, unknown>, queryString, key);
        }
        const queryParameter = getQueryParameter(key, value, objName);

        if (queryString) {
            return `${queryString}&${queryParameter}`;
        }

        return queryParameter;
    };

    const getQueryParameter = (key: string, value: unknown, objName?: string) => {
        return objName
            ? `${objName}.${key}=${encodeURIComponent(value as string)}`
            : `${key}=${encodeURIComponent(value as string)}`;
    };

    return {
        buildUrl,
        stripQuery
    };
};
